import React, { Component } from "react";
import {Helmet} from "react-helmet";
import "./Layout.css";
import { Header } from "./Header";
import { Footer } from "./Footer";

export class Layout extends Component {
  render() {
    const { locale, location } = this.props;
    return (
      <div className="Layout">
        <Helmet htmlAttributes={{
            lang: locale,
          }}
          titleTemplate="Julkinen rekisteri (Tukes) - %s"
          defaultTitle="Julkinen rekisteri (Tukes)"
        />
        <Header locale={locale} location={location} />
        {this.props.children}
        <Footer locale={locale} location={location} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Layout/Layout.js